import type { ReactNode } from 'react';

import { mergeClassNames } from '@/lib/utils';

interface InfoRowProps {
  label: string;
  value: string;
  valueClassName?: string;
  subValue?: string;
  // An info icon beside the label.
  tooltip?: ReactNode;
}

export const InfoRow = ({
  label,
  value,
  valueClassName,
  subValue,
  tooltip,
}: InfoRowProps) => {
  const labelEl = <p className="text-sm text-gray-700">{label}</p>;
  const valueEl = (
    <p
      className={mergeClassNames(
        'text-sm font-semibold text-gray-900',
        valueClassName
      )}
    >
      {value}
    </p>
  );

  return (
    <div
      className={mergeClassNames(
        'flex justify-between',
        subValue ? 'items-start gap-3' : 'items-center'
      )}
    >
      {tooltip ? (
        <div className="flex items-center gap-1">
          {labelEl}
          {tooltip}
        </div>
      ) : (
        labelEl
      )}
      {subValue ? (
        <div className="flex flex-col items-end gap-1">
          {valueEl}
          <p className="text-xs text-gray-600">{subValue}</p>
        </div>
      ) : (
        valueEl
      )}
    </div>
  );
};
